import { DocumentType } from '../../../operations/createDocument/DocumentType';

export function getDocExtension(docType: DocumentType): string {
  switch (docType) {
    case DocumentType.Word:
      return '.docx';
    case DocumentType.Excel:
    case DocumentType.ExcelSurvey:
    case DocumentType.ExcelForm:
      return '.xlsx';
    case DocumentType.PowerPoint:
      return '.pptx';
    case DocumentType.OneNote:
      return '';
    case DocumentType.Text:
      return '.txt';
    case DocumentType.Visio:
      return '.vsdx';
    case DocumentType.Bohemia:
      return '.b';
    case DocumentType.Prague:
      return '.prague';
  }
}

export function getDialogTitle(
  docType: DocumentType,
  strings: {
    CreateWord?: string;
    CreateExcel?: string;
    CreatePowerPoint?: string;
    CreateOneNote?: string;
    CreateExcelSurvey?: string;
    CreateFormForExcel?: string;
    CreateVisio?: string;
    CreateText?: string;
    CreateBohemia?: string;
    CreatePrague?: string;
  }): string | undefined {
  let dialogTitle: string | undefined = '';
  switch (docType) {
    case DocumentType.Word:
      dialogTitle = strings.CreateWord;
      break;
    case DocumentType.Excel:
      dialogTitle = strings.CreateExcel;
      break;
    case DocumentType.PowerPoint:
      dialogTitle = strings.CreatePowerPoint;
      break;
    case DocumentType.OneNote:
      dialogTitle = strings.CreateOneNote;
      break;
    case DocumentType.ExcelSurvey:
      dialogTitle = strings.CreateExcelSurvey;
      break;
    case DocumentType.Text:
      dialogTitle = strings.CreateText;
      break;
    case DocumentType.ExcelForm:
      dialogTitle = strings.CreateFormForExcel;
      break;
    case DocumentType.Visio:
      dialogTitle = strings.CreateVisio;
      break;
    case DocumentType.Bohemia:
      dialogTitle = strings.CreateBohemia;
      break;
    case DocumentType.Prague:
      dialogTitle = strings.CreatePrague;
      break;
  }

  return dialogTitle;
}
